<template>
  <div class="detail-statistic">
      <h3 class="detail-statistic__title">{{componentData.test_name}}</h3>
      <p class="difficulty-text">Сложность: 
          <span class="difficulty-text__value" :style="styleFunc(componentData.testDifficalty)">{{componentData.testDifficalty}}</span>
          <span>{{componentData.user_tested}}/{{componentData.user_passed}}</span>
        </p>
        <div class="table">
            <div class="table__header">
                <div class="row">
                    <span>Вопрос</span>
                    <span>Сложность</span>
                    <span>{{mobileMode ? 'Верно' : 'Верных ответов'}}</span>
                    <span>{{mobileMode ? 'Неверно' : 'Неверных ответов'}}</span>
                    <span>{{mobileMode ? '' : 'Соотношение'}}</span>
                </div>
            </div>
            <div class="table__body">
            <div class="row" v-for="(question, index) of questions" :key="index">
                <div class="col col-question">
                    <span>{{question.title}}</span>
                </div>
                <div class="col col-difficalty">
                    <span v-if="mobileMode">Сложность</span>
                    <span :style="styleFunc(question.testDifficalty)">{{question.testDifficalty}}</span>
                </div>
                <div class="col">
                    <span v-if="mobileMode">Верно</span>
                    <span>{{question.correctAnswers}}</span>
                </div>
                <div class="col">
                    <span v-if="mobileMode">Неверно</span>
                    <span>{{question.wrongAnswers}}</span>
                </div>
                <div class="col">
                    <span v-if="mobileMode">Соот-ние</span>
                    <span>{{question.successRate/100}}</span>
                </div>
            </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
    data() {
        return {
            questions:[]
        }
    },
    props:{
        componentData:Object
    },
    methods: {
        styleFunc(value){
            let color=''
            if(value==='Сложный'){
                color='#f56c6c'
            }else if(value==='Легкий'){
                color = '#67C23A'
            }else{
                color = '#E6A23C'
            }
        return {backgroundColor: color, color:'white', borderRadius: '10px'}
        }
    },
    computed:{
        mobileMode(){
            return this.$store.state.mobileMode
        }
    },
    mounted() {
        this.axios.get(`api/results/{did}/tresults/${this.componentData.test_id}`).then(res=>{
            this.questions = res.data.stats
        })
    },
}
</script>

<style lang="scss">
    .detail-statistic{
        height: 90%;
        display: grid;
        row-gap: 10px;
        grid-template-rows: max-content max-content 1fr;
        .difficulty-text,
        .detail-statistic__title{
            margin: 0;
        }
        .table{
            height: 100%;
            display: grid;
            grid-template-rows: max-content 1fr;
            overflow: hidden;
        }
        .difficulty-text{
            color: $regular-text-clr;
            display: grid;
            column-gap: 10px;
            grid-template-columns: 1fr 1fr 1fr;
            max-width: max-content;
            align-items: center;
        }
        .difficulty-text__value{
            padding:5px 10px;

        }
        .row{
            justify-items: center;
            align-items: center;
            text-align: center;
            display: grid;
            column-gap: 10px;
            padding: 10px;
            grid-template-columns: 3fr 1fr 1fr 1fr 1fr;
            border-bottom: 1px solid $placeholder-text-clr;
        }
        .table__header{
            padding-right: 6px;
            font-weight: bold;
            background-color: $basic-white;
            border-bottom: 2px solid $secondary-text-clr;
        }
        .table__header .row{
            border: none
        }
        .table__body{
            width: 100%;
            height: 100%;
            overflow-y: auto;
            color: $regular-text-clr;
        }
        .cell-difficalty{
            color: $basic-white;
            width: 100%;
            height: 30px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .cell-question{
            justify-self: flex-start;
            text-align: left;
        }
    }
    @media (max-width: 800px){
        .detail-statistic{
            .table{
                grid-template-rows: 1fr;
            }
            .table__header{
                display: none;
            }
            .table__body{
                display: grid;
                row-gap: 20px;
                max-height:450px;
            }
            .row{
                -webkit-box-shadow: 0px 2px 5px 0px rgba(50, 50, 50, 0.25);
                -moz-box-shadow:    0px 2px 5px 0px rgba(50, 50, 50, 0.25);
                box-shadow:         0px 2px 5px 0px rgba(50, 50, 50, 0.25);
                border: none;
                height: max-content;
                row-gap: 10px;
                grid-template-columns: repeat(3, 1fr) 2fr;
            } 
            .col{
                height: 100%;
                display: grid;
                align-items: center;
                span:last-child{
                    color: $primary-text-clr;
                    font-weight: bold;
                }
            }
            .col-question{
                grid-column-start: 1;
                grid-column-end: 5;
            }  
            .col-difficalty{
                span{
                    padding: 5px;
                }
            }
        }
    }
    
</style>